import DefaultBlock from "/scripts/default/block";
import gsap from "gsap";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

export default class CoreFree extends DefaultBlock {
	init() {
		const el = {
			windmill: this.block.querySelector("#core-free-windmill"),
			indicator: this.block.querySelector("#core-free-indicators"),
			indicators: this.block.querySelectorAll(".core-free-indicator"),
		};

		this.el = el;
		this.initCoreFree();
	}

	setCoreFree() {
		watchPreferredMotion(() => {
			gsap.to(this.el.indicators, {
				autoAlpha: 0,
				transformOrigin: "50% 50%",
			});
		});
	}

	playCoreFree() {
		const tl = gsap.timeline({
			repeat: -1,
		});

		watchPreferredMotion(() => {
			tl.to(
				this.el.indicators,
				{
					keyframes: {
						autoAlpha: [0, 1, 0],
					},
					stagger: {
						each: 0.05,
						ease: "power2.inOut",
						repeat: -1,
					},
					duration: 1.6,
				},
				0
			);
		});
	}

	initCoreFree() {
		this.setCoreFree();
		this.playCoreFree();
	}
}
